"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Anonymous = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 19,
  height: 10,
  viewBox: "0 0 19 10",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.25 1.29a2.68 2.68 0 011.03-.773c3.14-1.296 7.97.253 7.97.253S15.944 5.3 12.805 6.595c-1.254.532-2.711.026-3.555-1.125-.852 1.142-2.3 1.648-3.555 1.125C4.577 6.077 3.75 5.5 3.25 4.982V9.5a.5.5 0 01-1 0V3.805C1.579 2.948.763 1.73.25.77c0 0 4.829-1.55 7.97-.253.401.17.755.436 1.03.774zM7.228 4.263c.146-.12.255-.278.315-.457.11-.258.123-.548.036-.816a.526.526 0 00-.261-.32 5.88 5.88 0 00-2.177-.346c-.355 0-.712.02-1.055.05.731.884 1.603 1.713 2.49 2.082a.35.35 0 00.143.028c.187-.025.363-.101.509-.22zm4.542.221a.35.35 0 00.143-.028c.88-.366 1.75-1.198 2.484-2.07a11.68 11.68 0 00-1.05-.05 5.88 5.88 0 00-2.176.345c-.276.104-.428.616-.214 1.125a1.009 1.009 0 00.813.678z",
  className: "fill"
}));

var _default = Anonymous;
exports.default = _default;